import React, { useMemo } from 'react';
import Icon from '../AppIcon';

export default function CampaignScopeToolbar({
  campaigns = [],
  campaignId = '',
  onCampaignChange,
  loadingCampaigns = false,
  period = null,
  onPeriodChange = null,
  periodOptions = null,
  className = '',
}) {
  const options = useMemo(() => {
    return (campaigns || []).filter((c) => c.status !== 'draft');
  }, [campaigns]);

  const selectedLabel =
    campaignId === ''
      ? 'Toutes les campagnes'
      : options.find((c) => String(c._id || c.id) === String(campaignId))?.name ||
        'Campagne';

  return (
    <div
      className={`flex flex-col gap-3 rounded-2xl border border-border/80 bg-muted/20 px-4 py-3 sm:flex-row sm:items-center sm:justify-between ${className}`}
    >
      <div className="flex min-w-0 flex-1 flex-col gap-2 sm:flex-row sm:items-center sm:gap-4">
        <span className="inline-flex shrink-0 items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          <Icon name="Filter" size={14} />
          Filtres
        </span>
        <select
          id="campaign-scope-select"
          value={campaignId}
          disabled={loadingCampaigns}
          onChange={(e) => onCampaignChange?.(e.target.value)}
          className="w-full min-w-0 flex-1 rounded-lg border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring disabled:opacity-60 sm:max-w-sm"
          aria-label="Campagne"
        >
          <option value="">Toutes les campagnes</option>
          {options.map((c) => {
            const id = c._id || c.id;
            return (
              <option key={id} value={id}>
                {c.name}
              </option>
            );
          })}
        </select>
        {period != null && onPeriodChange && periodOptions?.length ? (
          <select
            id="campaign-scope-period"
            value={period}
            onChange={(e) => onPeriodChange(e.target.value)}
            className="w-full rounded-lg border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring sm:w-44"
            aria-label="Période"
          >
            {periodOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        ) : null}
      </div>
      <p className="text-xs text-muted-foreground sm:max-w-xs sm:text-right">
        {campaignId === ''
          ? 'Statistiques globales du périmètre CRM.'
          : `« ${selectedLabel} »`}
      </p>
    </div>
  );
}
